'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyFields = exports.extractFields = exports.stripFields = exports.selectors = exports.fieldsAll = exports.fields = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let fields = exports.fields = {
    error: (0, _symbol2.default)((0, _utils.internal)('error')),
    id: (0, _symbol2.default)((0, _utils.internal)('id')),
    isCreated: (0, _symbol2.default)((0, _utils.internal)('isCreated')),
    isCreating: (0, _symbol2.default)((0, _utils.internal)('isCreating')),
    isModified: (0, _symbol2.default)((0, _utils.internal)('isModified')),
    isRead: (0, _symbol2.default)((0, _utils.internal)('isRead')),
    isReading: (0, _symbol2.default)((0, _utils.internal)('isReading')),
    isRemoved: (0, _symbol2.default)((0, _utils.internal)('isRemoved')),
    isRemoving: (0, _symbol2.default)((0, _utils.internal)('isRemoving')),
    isUpdated: (0, _symbol2.default)((0, _utils.internal)('isUpdated')),
    isUpdating: (0, _symbol2.default)((0, _utils.internal)('isUpdating')),
    tempId: (0, _symbol2.default)((0, _utils.internal)('tempId'))
};
let fieldsAll = exports.fieldsAll = [fields.error, fields.id, fields.isCreated, fields.isCreating, fields.isModified, fields.isRead, fields.isReading, fields.isRemoved, fields.isRemoving, fields.isUpdated, fields.isUpdating, fields.tempId];
let selectors = exports.selectors = {
    error: item => item[fields.error],
    hasCommited: item => item[fields.isRead] || item[fields.isCreated] || item[fields.isRemoved] || item[fields.isUpdated],
    id: item => item[fields.id],
    isChanging: item => item[fields.isReading] || item[fields.isCreating] || item[fields.isRemoving] || item[fields.isUpdating],
    isCreated: item => item[fields.isCreated],
    isCreating: item => item[fields.isCreating],
    isModified: item => item[fields.isModified],
    isRead: item => item[fields.isRead],
    isReading: item => item[fields.isReading],
    isRemoved: item => item[fields.isRemoved],
    isRemoving: item => item[fields.isRemoving],
    isUnchanged: item => !item[fields.isReading] && !item[fields.isCreating] && !item[fields.isRemoving] && !item[fields.isUpdating],
    isUpdated: item => item[fields.isUpdated],
    isUpdating: item => item[fields.isUpdating],
    key: item => item[fields.id] || item[fields.tempId],
    neverCommited: item => !item[fields.isRead] && !item[fields.isCreated] && !item[fields.isRemoved] && !item[fields.isUpdated],
    tempId: item => item[fields.tempId]
};
let stripFields = exports.stripFields = obj => {
    let copy = (0, _extends3.default)({}, obj);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(fieldsAll), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            let key = _step.value;

            delete copy[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return copy;
};
let extractFields = exports.extractFields = obj => {
    var _ref;

    return _ref = {}, (0, _defineProperty3.default)(_ref, fields.id, obj[fields.id]), (0, _defineProperty3.default)(_ref, fields.tempId, obj[fields.tempId]), (0, _defineProperty3.default)(_ref, fields.error, obj[fields.error]), (0, _defineProperty3.default)(_ref, fields.isModified, obj[fields.isModified]), (0, _defineProperty3.default)(_ref, fields.isReading, obj[fields.isReading]), (0, _defineProperty3.default)(_ref, fields.isRead, obj[fields.isRead]), (0, _defineProperty3.default)(_ref, fields.isCreating, obj[fields.isCreating]), (0, _defineProperty3.default)(_ref, fields.isCreated, obj[fields.isCreated]), (0, _defineProperty3.default)(_ref, fields.isRemoving, obj[fields.isRemoving]), (0, _defineProperty3.default)(_ref, fields.isRemoved, obj[fields.isRemoved]), (0, _defineProperty3.default)(_ref, fields.isUpdating, obj[fields.isUpdating]), (0, _defineProperty3.default)(_ref, fields.isUpdated, obj[fields.isUpdated]), _ref;
};
let copyFields = exports.copyFields = (target, fieldsSource) => (0, _extends3.default)({}, target, extractFields(fieldsSource));
//# sourceMappingURL=fields.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/resource/fields.js